<template>
  <div class="text-grey">
    <div class="mt-3 mx-3">
      <h4 class="font-weight-lighter filter" @click="toggleFilter">
        Filters
        <img src="img/Filters.png" alt="filter" />
      </h4>
      <hr />
    </div>
    <div
      :class="{
        openFilterbar: filter,
        'mobile-filter': isMobileView,
      }"
      v-show="!isMobileView || filter"
    >
      <div v-if="keywordFacet.doc_count > 0">
        <div
          v-for="(keyword, index) in keywordFacet.attribute_name.buckets"
          :key="index"
        >
          <div
            v-if="keyword.key !== 'Description' && keyword.key !== 'Country'"
          >
            <h6
              class="collapse-block-title mt-3 text-primary mx-3"
              v-b-toggle="keyword.key"
            >
              {{ keyword.key }}
              <span class="tx-13"
                ><b-icon-chevron-down></b-icon-chevron-down
              ></span>
            </h6>

            <b-collapse
              :id="keyword.key"
              visible
              accordion="myaccordion1"
              role="tabpanel"
            >
              <div>
                <div>
                  <div
                    class="custom-control custom-checkbox collection-filter-checkbox mx-3"
                    v-for="(item, index) in keyword.attribute_value.buckets"
                    :key="index"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :value="item.key"
                      v-model="applyFilter"
                      :id="item.key"
                      @change="appliedFilter(keyword.key, item.key)"
                    />
                    <label class="custom-control-label" v-bind:for="item.key">{{
                      item.key
                    }}</label>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
      <div class="price-filter mx-3 mt-4">
        <h6 class="text-primary">Price Range</h6>
        <br />
        <vue-slider
          v-model="priceRange"
          :min="0"
          :max="1500"
          :interval="10"
          :tooltip="'always'"
          :dot-options="[
            { style: { backgroundColor: '#ff8a00' } },
            { style: { backgroundColor: '#ff8a00' } },
          ]"
          @drag-end="updatePriceFilter"
        />
        <p class="mt-2">
          Selected Range: {{ priceRange[0] }} - {{ priceRange[1] }}
        </p>
      </div>
      <button
        v-if="isMobileView"
        class="close-filter-btn"
        @click="toggleFilter"
      >
        Close
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
export default {
  components: {
    VueSlider,
  },
  data() {
    return {
      applyFilter: [],
      filter: false,
      priceRange: [10, 1500],
      isMobileView: window.innerWidth <= 1080,
    };
  },
  computed: {
    ...mapGetters({
      keywordFacet: "search/getKeywordFilters",
      minPrice: "search/getmaxPriceFilter",
      maxPrice: "search/getmaxPriceFilter",
    }),
  },
  watch: {
    minPrice(val) {
      this.priceRange[0] = val.min;
    },
    maxPrice(val) {
      this.priceRange[1] = val.max;
    },
  },
  methods: {
    ...mapActions("search", ["setPriceRangeFilter", "changeKeywordFilter"]),
    appliedFilter(key, value) {
      this.changeKeywordFilter({ key, value });
      this.$emit("allFilters", this.applyFilter);
    },
    updatePriceFilter() {
      this.setPriceRangeFilter({
        min: this.priceRange[0],
        max: this.priceRange[1],
      });
    },
    toggleFilter() {
      this.filter = !this.filter;
    },
    handleResize() {
      this.isMobileView = window.innerWidth <= 1080;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
<style scoped>
.filter {
  display: flex;
  gap: 10px;
  width: 120px;
  background-color: var(--primarycolor);
  padding: 10px 14px;
  border-radius: 30px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
  justify-content: start;
  align-items: center;
  color: #fff;
}
.price-filter {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  background: #f9f9f9;
}
@media screen and (max-width: 1080px) {
  .mobile-filter {
    position: fixed;
    top: 0;
    right: 0;
    width: 80%;
    height: 100vh;
    background: white;
    z-index: 1000;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
    padding: 20px;
    overflow-y: auto;
    transition: transform 0.3s ease-in-out;
    transform: translateX(100%);
  }
  .openFilterbar {
    transform: translateX(0);
  }
  .close-filter-btn {
    background: #ff8a00;
    color: white;
    padding: 10px;
    border: none;
    width: 100%;
    margin-top: 20px;
    border-radius: 5px;
    cursor: pointer;
  }
}
</style>
